<template>
  <Button :label="_t('label_Ad-hoc_Upload')" class="p-button-success" @click="uploadDialog=true"/>
  <Dialog v-model:visible="uploadDialog" style="min-width: 500px">
    <template #header>
      <h3>{{ _t('label_Ad-hoc_save_attachment') }}</h3>
    </template>
    <p>{{ _t('label_Select_folder') }}</p>
    <div class="p-mb-4">
      <OrganizationLink v-model="selectedOrg" :editMode="true" :required-field="true"/>
    </div>
    <FileUpload :auto="true"
                :choose-label="_t('label_Select_file')"
                :customUpload="true"
                :disabled="uploading"
                :fileLimit="5"
                :maxFileSize="200*1024*1024*1024"
                :multiple="true" :showCancelButton="false"
                :showUploadButton="false" @beforeSend="onUploadStart"
                @beforeUpload="onUploadStart" @error="onUploadError"
                @progress="onUploadProgress" @upload="onUploadComplete"
                @uploader="onUploadFiles"
    >
      <template #empty>
        <p>{{ _t('label_Drag_and_drop') }}</p>
      </template>
    </FileUpload>
    <div class="p-pt-2" style="width: 100%; text-align: right">
      <Button :label="_t('label_Select_attachment')" class="p-button-success" @click="uploadDialog = false"/>
    </div>
  </Dialog>
</template>

<script>
import {mapActions} from "vuex";
import OrganizationLink from "./ixarma/OrganizationLink";
import { formatApiError } from "@/utils/apiError";
import { getCurrentOrganizationId } from "@/state/organizationContextOptions";
import { logError } from "@/utils/appLogger";

export default {
  components: {OrganizationLink},
  name: 'upload-file',
  emits: ['uploaded'],
  data: () => ({
    uploadDialog: false,
    selectedOrg: {
      orgId: getCurrentOrganizationId(),
      orgName: '',
    },
    uploading: false,
  }),
  methods: {
    ...mapActions({
      'uploadFile': 'attachments/uploadFile',
      'multiplyUpload': 'attachments/multiplyUpload',
    }),
    async onUploadFiles(event) {
      const files = Array.isArray(event.files) ? event.files : []

      if (!files.length) return

      this.uploading = true

      try {
        await Promise.all(files.map(file => {
          const formData = new FormData();
          formData.append('file', file);
          formData.append('orgId', this.selectedOrg.orgId ?? 1);

          return this.uploadFile(formData)
        }))
        this.$emit('uploaded', true)
      } catch (error) {
        this.showUploadError(error)
      } finally {
        this.uploading = false
      }
    },
    onUploadStart() {
      this.uploading = true
    },
    onUploadComplete() {
      this.uploading = false
    },
    onUploadError(event) {
      this.uploading = false
      this.showUploadError(event?.error ?? event)
    },
    onUploadProgress() {
      // PrimeVue emits this event frequently; upload state is already tracked.
    },
    showUploadError(error) {
      const message = formatApiError(error, 'Unable to upload file')

      if (this.$root?.showMessage) {
        this.$root.showMessage(message, 'error')
      } else {
        logError(message, error)
      }
    },
  }
}
</script>

<style scoped>
::v-deep(.p-fileupload-files .p-button.p-component.p-button-icon-only) {
  display: none;
}

::v-deep(.p-fileupload-files .p-fileupload-filename) {
  width: 100%;
}

::v-deep(.p-fileupload-choose) {
  color: #ffffff;
  background: #689F38;
  border: 1px solid #689F38;
}
</style>
